import Tooltip, { type Props } from '@carvana/showroom-tooltip/Base/Tooltip';
import cx from 'classnames';

export default function StyledTooltip(props: Props) {
  return (
    <Tooltip
      {...props}
      classNames={{
        tooltip: cx('z-10', props.classNames?.tooltip)
      }}
      disallowPropagation={false}
    />
  );
}
